<template>
	<section class="main-menu__cats-wrapper">
		<content-container>
			<div class="wrapper">
				<div class="slider-wrapper">
					<button v-if="!isIE" @click="prevSlide" class="back-arrow-icon" :class="{ show: showPrevArrow }">
						<icon-base width="16px" height="14px" :iconName="'Scroll Back'">
							<icon-arrow-right />
						</icon-base>
					</button>
					<VueSlickCarousel
						v-if="!isIE && menuCatsObject.length"
						v-bind="settings"
						ref="carousel"
						@afterChange="checkSlideCount"
					>
						<div
							v-for="(category, index) in menuCatsObject"
							:key="category.id"
							class="main-menu__cat-item-wrapper"
							:class="{ active: category.isActive }"
						>
							<div
								class="main-menu__cat-item"
								:class="{ active: category.isActive }"
								:index="category.index"
								@click="
									handleClick(category, index);
									scrollTo(`#${category.id}`);
								"
							>
								{{ category.label }}
							</div>
						</div>
					</VueSlickCarousel>
					<div v-if="isIE" class="main-menu__cats">
						<div
							v-for="(category, index) in menuCatsObject"
							:key="category.id"
							class="main-menu__cat-item-wrapper"
							:class="{ active: category.isActive }"
						>
							<div
								class="main-menu__cat-item"
								:class="{ active: category.isActive }"
								:index="category.index"
								@click="
									handleClick(category, index);
									scrollTo(`#${category.id}`);
								"
							>
								{{ category.label }}
							</div>
						</div>
					</div>
					<button v-if="!isIE" @click="nextSlide" class="forward-arrow-icon" :class="{ show: showNextArrow }">
						<icon-base width="16px" height="14px" :iconName="'Scroll Forward'">
							<icon-arrow-right />
						</icon-base>
					</button>
				</div>
				<button class="cart-button" type="button" id="cartCountButton">
					<span class="cart-button-icon">
						<icon-base width="22px" height="22px" :iconName="'Cart'">
							<icon-bag />
						</icon-base>
					</span>
					<span class="cart-button-text"> My Order : {{ currentCartCount }} </span>
				</button>
			</div>
		</content-container>
	</section>
</template>

<script>
import Vue from "vue";
import ContentContainer from "./ContentContainer.vue";
import IconBase from "./IconBase.vue";
import IconArrowRight from "./icons/IconArrowRight.vue";
import IconBag from "./icons/IconBag.vue";

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "intersection-observer/intersection-observer";
import browserDetect from "vue-browser-detect-plugin";
Vue.use(browserDetect);

export default {
	name: "MenuCategories",
	components: {
		ContentContainer,
		IconBase,
		IconBag,
		IconArrowRight,
		VueSlickCarousel,
	},
	props: {
		categories: {
			type: Array,
			default: () => [],
		},
		cartCount: {
			type: [String, Number],
		},
	},
	data: function () {
		return {
			menuCatsObject: [],
			currentCartCount: this.cartCount,
			settings: {
				arrows: false,
				variableWidth: true,
				infinite: false,
				speed: 200,
				swipeToSlide: true,
				waitForAnimate: false,
			},
			observer: null,
			showPrevArrow: false,
			showNextArrow: true,
			isIE: false,
		};
	},
	watch: {
		categories: function (newCategories) {
			this.menuCatsObject = newCategories.map((cat, index) => {
				const toObserve = document.querySelector(`#${cat.id}`);
				if (toObserve && this.observer) {
					this.observer.observe(document.querySelector(`#${cat.id}`));
				}

				const menuCatObject = {
					label: cat.label,
					id: cat.id,
					isActive: index === 0,
				};
				return menuCatObject;
			});
		},
		cartCount: function (newCartCount) {
			this.currentCartCount = newCartCount;
		},
	},
	created() {
		this.observer = new IntersectionObserver(this.onElementObserved, {
			rootMargin: "-35% 0px -65% 0px",
			threshold: 0,
		});
		this.isIE = this.$browserDetect.isIE;
	},
	mounted() {
		this.menuCatsObject = this.categories.map((cat, index) => {
			const toObserve = document.querySelector(`#${cat.id}`);
			if (toObserve && this.observer) {
				this.observer.observe(document.querySelector(`#${cat.id}`));
			}
			const menuCatObject = {
				label: cat.label,
				id: cat.id,
				isActive: index === 0,
			};
			return menuCatObject;
		});
	},
	beforeDestroy() {
		this.observer.disconnect();
	},
	methods: {
		handleClick(selected, index) {
			this.menuCatsObject.forEach((cat) => {
				if (cat.isActive === true) {
					cat.isActive = false;
				}
			});

			selected.isActive = true;
			if (!this.isIE) {
				this.$refs.carousel.goTo(index);
			}
		},
		nextSlide() {
			this.$refs.carousel.next();
		},
		prevSlide() {
			this.$refs.carousel.prev();
		},
		checkSlideCount() {
			const currentSlide = document.querySelector(".slick-current").getAttribute("data-index");
			const slideCount = document.querySelector(".slick-track").childElementCount;

			if (currentSlide > 0) {
				this.showPrevArrow = true;
			} else {
				this.showPrevArrow = false;
			}

			if (currentSlide == slideCount - 1) {
				this.showNextArrow = false;
			} else {
				this.showNextArrow = true;
			}
		},
		scrollTo(selector) {
			const topOfEl = document.querySelector(selector).getBoundingClientRect().top + window.scrollY - 40;
			const stickyHeight = document.querySelector(".sticky-wrapper").offsetHeight;
			const top = topOfEl - stickyHeight;

			if (this.isIE) {
				window.scroll(0, document.querySelector(selector).getBoundingClientRect().top - 40);
			} else {
				window.scroll({
					top: top,
					behavior: "smooth",
				});
			}
		},
		onElementObserved(entries) {
			entries.forEach(({ target, isIntersecting }) => {
				if (isIntersecting) {
					const targetId = target.id;
					const catIndex = this.menuCatsObject.findIndex((cat) => targetId === cat.id);
					this.handleClick(this.menuCatsObject[catIndex], catIndex);
				}
			});
		},
	},
};
</script>

<style scoped lang="scss">
.main-menu__cats-wrapper {
	background-color: $gray_7;
	border: 1px solid $gray_8;
}

.wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;

	@media (min-width: $mobileLandscape) {
		flex-wrap: nowrap;
	}
}

.slider-wrapper {
	display: flex;
	align-items: center;
	overflow-x: auto;
	margin-left: -15px;
}

.back-arrow-icon {
	transition: opacity 200ms ease-in-out 0ms;
	transform: rotate(-180deg);
	opacity: 0;
	visibility: hidden;
}

.back-arrow-icon.show {
	opacity: 1;
	visibility: visible;
}

.forward-arrow-icon {
	transition: opacity 200ms ease-in-out 0ms;
	opacity: 0;
	visibility: hidden;
}

.forward-arrow-icon.show {
	opacity: 1;
	visibility: visible;
}

.slick-slider {
	margin-bottom: 0;
	padding: 0.5em 15px 0 0;
	display: flex !important;
	overflow-x: hidden;
}

.main-menu__cats {
	display: flex;
	align-items: center;
	overflow-x: auto;
}

.main-menu__cat-item-wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 10px 10px 10px;
}

.main-menu__cat-item-wrapper.active {
	border-bottom: 5px solid $tomato;
	padding-bottom: 5px;
}

.main-menu__cat-item {
	font-weight: 700;
	color: $black;
	font-size: 14px;
	text-decoration: none;
	white-space: nowrap;

	&:hover {
		color: $black;
		text-decoration: underline;
		cursor: pointer;
	}
}

.main-menu__cat-item.active {
	&:hover {
		text-decoration: none;
	}
}

.cart-button {
	@include transition(background-color, transform);
	font-size: 1.5rem;
	font-weight: 700;
	text-align: center;
	padding: 5px 10px;
	margin: 5px 0 5px 15px;
	background-color: $gold;
	border-radius: 22.5px;
	box-shadow: $box-shadow;
	display: flex;
	align-items: center;
	justify-content: center;
	white-space: nowrap;

	&:hover,
	&:focus {
		transform: translate(0, -2px);
		background-color: $royal;
	}
}

.cart-button-text {
	line-height: 1;
	margin: 0 15px;
}

.cart-button-icon {
	display: flex;
}
</style>